import { useEffect, useState } from "react";
import { Header } from "../../components/Header";
import { HeaderCategories } from "../../components/HeaderCategories";
import { Menu } from "../../components/Menu";
import { useParams, useSearchParams } from "react-router-dom";
import { useOrder } from "../../hooks/useOrder";
import { useAppConfig } from "../../hooks/useAppConfig";
import { ConfigType } from "../../contexts/AppConfigContext";
import { Loading } from "../../components/Loading";
import api from "../../services/api";

import "./index.css";
import { cepNoMask } from "../../functions/mask";
import Swal from "sweetalert2";
import { usePluginspace } from "../../hooks/usePluginspace";
import { useToast } from "../../hooks/useToast";
import { ModalImage } from "../../components/ModalImage";
import { OrderType, SellerInfo } from "../../contexts/OrderContext";
import { ProductType, VariationType } from "../../contexts/ProductsContext";
import { useProduct } from "../../hooks/useProduct";
import { useQuery } from "../../hooks/useQuery";
import { ModalProdutoCarrinho } from "../../components/ModalProdutoCarrinho/index";
import { ButtonProduct } from "../../components/buttonProduct/ButtonProduct";
import { useFaceBookPixel } from "../../hooks/useFacebookPixel";
import { ProductImage } from "./components/ProductImage";
import { ProductInfo } from "./components/ProductInfo";
import { ProductDescription } from "./components/ProductDescrition";
import { ProductVariation } from "./components/ProductVariation";
import { MeasurementGuideModal, MeasurementGuideProductType } from "../../components/MeasurementGuideModal";
import useAuth from "../../hooks/useAuth";
import useCart from "../../contexts/cartContext/cartContext";
import { safeJsonParse } from "./factory/helper";
import { LocationType, MultipleVariationTypes, CommentType, InterestType, StoresType, VariationImageType, ImageType } from "./productTypes";
import { productHelper } from "./factory/productHelper";
import { buildImages, getPricesAndVariations } from "./factory/mapData";
import { useSellerInfo } from "../../contexts/sellerInfoContext";
import { NO_VALUE_SELLER_DISCOUNT } from "../Catalog/auxCatalog";

export function Product() {
  const { pluginspace_id, product_id } = useParams();
  const useProductHelper = productHelper();
  const { trackAddToCart } = useFaceBookPixel();
  const { pushToOrder, getOrder } = useOrder();
  const { addProduct } = useCart();
  const { getToken, getThisPluginspace, registerAccess, getLocations } = usePluginspace();
  const { setCatalogId, setCpfVendorByLink, setUpdateCustomerCart, setDiscountValue, setSellerInfo, cpfVendorByLink, sellerInfo, catalogId } = useSellerInfo();
  const [locations, setLocations] = useState<Array<LocationType>>([]);
  const query = useQuery();
  const orderContext = useOrder();
  const [searchParams, setSearchParams] = useSearchParams();
  const [showFlag, setShowFlag] = useState(true);
  const [openDetails, setOpenDetails] = useState(true);

  const [cep, setCep] = useState("");
  const [cepAlarm, setCepAlarm] = useState(false);
  const [findCep, setFindCep] = useState(false);

  const [quantity, setQuantity] = useState(1);

  const { getAppConfig } = useAppConfig();
  const [config, setConfig] = useState<ConfigType | void>();
  const [loading, setLoading] = useState(true);

  const [product, setProduct] = useState<ProductType | null>(null);
  const [subcategoryName, setSubcategoryName] = useState("");
  const [variations, setVariations] = useState<Array<MultipleVariationTypes>>([]);

  const [selectedVariation, setSelectedVariation] = useState<any>({});
  const [price, setPrice] = useState(0);
  const [minorPrice, setMinorPrice] = useState(0);
  const [promotionalPrice, setPromotionalPrice] = useState(0);
  const [stock, setStock] = useState(0);
  const [img, setImg] = useState("");
  const [sku, setSku] = useState("");
  const [stores, setStores] = useState<Array<StoresType>>([]);
  const [selectedImg, setSelectedImg] = useState(0);
  const [variationImages, setVariationImages] = useState<Array<VariationImageType>>([]);
  const [variationImagesNow, setVariationImagesNow] = useState<Array<VariationImageType>>([]);

  const [modalImage, setModalImage] = useState(false);
  const [urlImageOpen, setUrlImageOpen] = useState("");
  const [orderFinded, setOrderFinded] = useState<OrderType | null>(null);
  const [pluginspaceData, setPluginspaceData] = useState<any>();

  const [loadingHeader, setLoadingHeader] = useState(true);

  const [modalOpen, setModalOpen] = useState(false);
  const [productModal, setProductModal] = useState<any | null>(null);

  const [imgGuide, setImgGuide] = useState<string | null>(null);
  const [measurementGuideProduct, setMeasurementGuideProduct] = useState<MeasurementGuideProductType[]>([]);

  // Estados para os ícones e Login
  const { loginInfo } = useAuth(); // Pegar o info do login atual
  const [animate, setAnimate] = useState(false);
  const [animateHeart, setAnimateHeart] = useState(false);
  const [favoriteProduct, setFavoriteProduct] = useState(false);
  const [favoriteId, setFavoriteId] = useState<string | null>(null); // Guardar o ID do favorito para poder apagar

  const [grandPrice, setGrandPrice] = useState(0);
  const [minimunPrice, setMinimunPrice] = useState(0);

  const [goToLastImagem, setGoToLastImagem] = useState(0);

  const { openToast } = useToast();

  async function getVendorInfoByCPFOrCode(cpf: string, code: string): Promise<{
    discountValue: number;
    sellerInfo: SellerInfo;
  }> {
    return await api
      .post(
        `/api/users/filter`,
        {
          type: 'seller',
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (res: any) => {
        if (res.data) {
          const sellerData = res.data.data.find((e: any) => e.cpf === cpf || e.sellerCode === code.toString());

          if (sellerData) {
            const seller: SellerInfo = {
              cpf: sellerData.cpf,
              image: sellerData.image,
              email: sellerData.email,
              id: sellerData.id,
              name: sellerData.name,
              numberPhone: sellerData.numberPhone,
              sellerCode: sellerData.sellerCode,
              pluginspaceId: parseInt(sellerData.pluginspaceId),
            };

            orderContext.setSellerInfoData(seller);
            if (sellerData.content) {
              const content = JSON.parse(sellerData.content);
              if (content.discount_value) {

                return {
                  discountValue: parseInt(content.discount_value),
                  sellerInfo: seller,
                };
              }
            }

            return {
              discountValue: 0,
              sellerInfo: seller,
            };
          }
        }

        return NO_VALUE_SELLER_DISCOUNT;
      })
      .catch((err) => {
        console.log(err);
        return NO_VALUE_SELLER_DISCOUNT;
      });
  }

  async function createVendorCart() {
    try {
      if (
        query.get("vendor") !== undefined &&
        query.get("vendor") !== "" &&
        query.get("vendor") != null
      ) {
        const x = query.get("vendor");

        const vendorDataRaw = atob(x!);

        const vendorData = JSON.parse(vendorDataRaw.replace(/([{,]\s*)(\w+)\s*:/g, '$1"$2":'));

        const code = vendorData.code;
        const cpf = vendorData.cpf;

        const discountValue = await getVendorInfoByCPFOrCode(cpf, code);
        const sellerInfo = discountValue.sellerInfo;
        const vendedorCPF = sellerInfo.cpf;
        orderContext.cpfVendorByLink(vendedorCPF);
        orderContext.setSellerCpfCnpj(vendedorCPF);
        orderContext.setShouldUpdadeCustomerCart(true);
        setUpdateCustomerCart(true)
        setCpfVendorByLink(sellerInfo.cpf);
        setUpdateCustomerCart(true);
        setDiscountValue(discountValue.discountValue)
        setSellerInfo(discountValue.sellerInfo);

        registerAccess(
          "product",
          vendedorCPF,
          parseInt(product_id!),
          window.location.pathname,
        );

        searchParams.delete("vendor");
        setSearchParams(searchParams);
      } else {
        registerAccess("product");
      }
    } catch (error) {
      console.log("Erro ao criar carrinho do vendedor:", error);
      registerAccess("product");
    }
  }

  useEffect(() => {
    createVendorCart();
    getConfig();
  }, []);

  useEffect(() => {
    getAllInfos();
  }, [product_id]);

  async function saveInfoSellerLinkCart() {
    if (orderContext.shouldUpdadeCart) {
      const orderToStorage = Object.assign(orderContext);
      await orderToStorage.encryptOrderStorage(orderToStorage);
    }
  }

  useEffect(() => {
    saveInfoSellerLinkCart();
  }, [orderContext.shouldUpdadeCart]);

  async function getAllInfos() {
    setLoading(true);
    await getOrderSaved();
    await getProduct();
    await checkFavorite(); // <-- Chama a verificação do favorito no carregamento
    const loc = await getLocations();

    setLocations(loc);
    setLoading(false);
  }

  // NOVA FUNÇÃO: Busca se o produto já é favorito para o usuário logado
  async function checkFavorite() {
    if (loginInfo && loginInfo.id) {
      try {
        const res = await api.get(
          `/api/product-favorite/customer/${loginInfo.id}/product/${product_id}`,
          { headers: { Authorization: `Bearer ${await getToken()}` } },
        );
        if (res.data && res.data.success && res.data.data) {
          const favData = Array.isArray(res.data.data)
            ? res.data.data[0]
            : res.data.data;
          if (favData) {
            setFavoriteProduct(true);
            setFavoriteId(favData.id);
          }
        }
      } catch (e) {
        console.log("Erro ao buscar status de favorito", e);
      }
    }
  }

  async function getOrderSaved() {
    const newOrder = await getOrder();
    setPluginspaceData(await getThisPluginspace());
    setOrderFinded(newOrder);
  }

  async function getStores() {
    const noMaskCep = cepNoMask(cep);
    await api
      .post(
        `api/variations/skuzipcode`,
        {
          zipcode: noMaskCep,
          skus: [sku],
          noVerifyStock:
            config && config.content.pdv.showOutStock ? true : false,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        },
      )
      .then(async (response) => {
        const newStores: Array<StoresType> = response.data.map(
          (str: StoresType) => {
            return {
              id: str.id,
              name: str.name,
              distance: str.distance,
              currentBalance: str.currentBalance,
            };
          },
        );
        setStores(newStores);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function getProduct() {
    try {
      const token = await getToken()
      const p: any = await useProductHelper.getProduct(product_id!, token);

      if (!p) {
        return
      }
      const variations = p.variations
      fitProduct(p);
      const { pricePreview, grandPrice, minimunPrice, promotionalPricePreview } = getPricesAndVariations(p.variations);
      setPrice(pricePreview);
      setMinimunPrice(pricePreview);
      setGrandPrice(grandPrice);
      setMinorPrice(minimunPrice);
      setStock(variations[0].inventory);

      const promotionalPriceCalculated = calculateDiscountFromParam(pricePreview, promotionalPricePreview.toString(),);
      setPromotionalPrice(promotionalPriceCalculated);

      await fitVariations(variations);
      const { variationFromImages, imgGuide }: { variationFromImages: Array<VariationImageType>, imgGuide: string | null } = buildImages(p.images);
      const imagensOrdenadas = variationFromImages.filter((imageVariation) => imageVariation.image.split("://")[1] !== "s3.amazonaws.com/img.ninegrid.com/").sort((a, b) => a.order - b.order);
      setImgGuide(imgGuide);

      setImg(variations[0].img);
      setVariationImagesNow(imagensOrdenadas);
      setMeasurementGuideProduct(p.measurementGuideProduct);

      variations.forEach(
        (variation: VariationType) => {
          if (variation.img && variationFromImages) {
            variationFromImages.push({
              sku: variation.sku,
              image: variation.img,
              order: -1,
            });
          }
        },
      );

      const variationImagesFiltered = variationFromImages.filter(
        (imageVariation) =>
          imageVariation.image.split("://")[1] !==
          "s3.amazonaws.com/img.ninegrid.com/",
      );

      await applySkuSelectionFromUrl(
        variations,
        variationImagesFiltered,
      );

      setVariationImages(variationImagesFiltered);

      const classificationName = await useProductHelper.getProductClassifications(p.classificationId, token);
      setSubcategoryName(classificationName || "");

    } catch (error) {
      console.log("Erro ao buscar produto:", error);
    }
  }

  function clearSkuParamFromUrl() {
    if (!searchParams.get("sku")) return;
    const nextSearchParams = new URLSearchParams(searchParams);
    nextSearchParams.delete("sku");
    setSearchParams(nextSearchParams);
  }

  function isVariationAvailable(
    variation: VariationType,
    showOutStock: boolean,
  ) {
    if (!variation.status) return false;
    if (showOutStock) return true;
    return variation.inventory - variation.minimumStock > 0;
  }

  function getSelectedContextFromVariation(variation: VariationType) {
    try {
      return safeJsonParse(variation.context);
    } catch (error) {
      return null;
    }
  }

  function mountVariationImagesNowBySku(
    allImages: VariationImageType[],
    skuSelected: string,
    contextSelected: any,
  ) {
    const sortImages = allImages
      .filter((image) => {
        if (image.sku === "") {
          return true;
        } else if (image.sku === skuSelected && skuSelected !== "") {
          return true;
        } else if (JSON.stringify(contextSelected).includes("VARIATION")) {
          return true;
        }
        return false;
      })
      .sort((a, b) => {
        if (a.sku && a.sku !== "") {
          if (b.sku && b.sku !== "") {
            return a.order - b.order;
          }
          return 1;
        }
        if (b.sku && b.sku !== "") {
          return -1;
        }
        return a.order - b.order;
      });

    setVariationImagesNow(sortImages);
    setGoToLastImagem(sortImages.length - 1);

    return sortImages;
  }

  async function applySkuSelectionFromUrl(
    loadedVariations: VariationType[],
    loadedImages: VariationImageType[],
  ) {
    const skuFromUrl = searchParams.get("sku");
    if (!skuFromUrl) return;

    try {
      const normalizedSku = skuFromUrl.trim();
      const variationFromSku = loadedVariations.find(
        (variation) => variation.sku === normalizedSku,
      );

      if (!variationFromSku) return;

      const conf = await getAppConfig();
      const showOutStock =
        conf &&
          conf.content &&
          conf.content.pdv &&
          conf.content.pdv.showOutStock
          ? true
          : false;

      if (!isVariationAvailable(variationFromSku, showOutStock)) {
        return;
      }

      const contextSelected = getSelectedContextFromVariation(variationFromSku);
      if (!contextSelected) return;

      const newPromotionalPrice = calculateDiscountFromParam(
        variationFromSku.price,
        variationFromSku.promotionalPrice.toString(),
      );

      setSelectedVariation(contextSelected);
      setPrice(variationFromSku.price);
      setStock(variationFromSku.inventory);
      setPromotionalPrice(newPromotionalPrice);
      setImg(variationFromSku.img);
      setSku(variationFromSku.sku);

      const sortedImages = mountVariationImagesNowBySku(
        loadedImages,
        variationFromSku.sku,
        contextSelected,
      );

      const imageIndex = sortedImages.findIndex(
        (variationImage) => variationImage.image === variationFromSku.img,
      );
      setSelectedImg(imageIndex >= 0 ? imageIndex : 0);
    } finally {
      clearSkuParamFromUrl();
    }
  }

  async function fitVariations(variations: VariationType[]) {
    let varitiationsFormated: MultipleVariationTypes[] = [];
    const conf = await getAppConfig();
    const objVt = safeJsonParse(variations[0].context);
    variations.forEach((vrt) => {
      const objVrtNew = safeJsonParse(vrt.context);
      Object.entries(objVrtNew).forEach((vrtContext) => {
        if (!Object.keys(objVt).includes(vrtContext[0])) {
          objVt[vrtContext[0]] = vrtContext[1];
        }
      });
    });
    const objSelected: any = {};
    Object.entries(selectedVariation).map((key) => {
      objSelected[key[0]] = key[1];
    });

    Object.keys(objVt).map((key) => {
      let values: string[] = [];
      variations.map((vrt) => {
        const obj = safeJsonParse(vrt.context);
        if (
          values &&
          obj[key] &&
          !values.includes(obj[key]) &&
          (vrt.inventory - vrt.minimumStock > 0 ||
            (conf && conf.content.pdv.showOutStock)) &&
          vrt.status
        ) {
          values.push(obj[key]);
        }
      });
      objSelected[key] = values[0];
      if (values.length > 0) {
        varitiationsFormated.push({
          name: key,
          values: values,
        });
      }
    });
    setVariations(varitiationsFormated);
    let objToSelect: any = {};
    varitiationsFormated.forEach((vari) => {
      if (vari.values.length > 0) {
        objToSelect[vari.name] = vari.values[0];
      }
    });
    let skuFinded = "";
    let foundValid = false;
    variations.forEach((vrt) => {
      if (JSON.stringify(objToSelect) === vrt.context) {
        skuFinded = vrt.sku;
        setPrice(vrt.price);
        const newPromotinaolPrice = calculateDiscountFromParam(
          vrt.price,
          vrt.promotionalPrice.toString(),
        );
        setPromotionalPrice(newPromotinaolPrice);
        setSku(skuFinded);
        foundValid = true;
      }
    });
    if (foundValid) {
      setSelectedVariation(objToSelect);
    } else {
      setSelectedVariation({});
    }
  }

  function fitProduct(pdt: ProductType) {
    let variationsSkus: string[] = [];
    let variationsFit: VariationType[] = [];
    if (pdt.variations) {
      for (let i = 0; i < pdt.variations.length; i++) {
        variationsSkus.push(pdt.variations[i].sku);
        variationsFit.push(pdt.variations[i]);
      }
    }
    pdt.variations = variationsFit;
    pdt.variations.map((vt) => {
      if (vt.img && !vt.img.includes("http")) {
        vt.img = `https://s3.amazonaws.com/img.ninegrid.com/${vt.img}`;
      }
    });
    setProduct(pdt);
  }

  async function getConfig() {
    setLoadingHeader(true);
    const config = await getAppConfig();
    const showFlag = config?.content.showFlagDiscount || false;
    setShowFlag(showFlag);
    setConfig(config);
    setLoadingHeader(false);
  }

  function selectVariation(variationName: string, variationValue: string) {
    const objSelected: any = {};
    Object.entries(selectedVariation).map((key) => {
      objSelected[key[0]] = key[1];
    });
    if (objSelected[variationName] === variationValue)
      delete objSelected[variationName];
    else objSelected[variationName] = variationValue;
    setSelectedVariation(objSelected);
    changeVariationSelected(objSelected);
  }

  function changeVariationSelected(objSelected: any) {
    let findedSku = false;
    selectVariationImages(objSelected);
    product?.variations.forEach((vt, index) => {
      const context = safeJsonParse(vt.context);
      const sizeTypes = Object.keys(context).length;
      const sizeTypesSent = Object.keys(objSelected).length;
      let sizeComparation = 0;
      Object.keys(context).map((key) => {
        if (context[key] === objSelected[key]) {
          sizeComparation++;
        }
      });
      if (sizeComparation === sizeTypes && sizeTypesSent === sizeTypes) {
        findedSku = true;
        const indexForImage = variationImages.findIndex(
          (variationImg) => variationImg.image === vt.img,
        );
        setSelectedImg(indexForImage);
        setPrice(vt.price);
        setStock(vt.inventory);
        const newPromotinaolPrice = calculateDiscountFromParam(
          vt.price,
          vt.promotionalPrice.toString(),
        );

        setPromotionalPrice(newPromotinaolPrice);

        setImg(vt.img);
        setSku(vt.sku);
        if (findCep) {
          getStores();
        }
      }
    });
    if (!findedSku) {
      const compatibleVariations =
        product?.variations.filter((vt) => {
          const context = safeJsonParse(vt.context);
          return Object.entries(objSelected).every(
            ([key, value]) => context[key] === value,
          );
        }) || [];

      if (compatibleVariations.length > 0) {
        const minCompatiblePrice = Math.min(
          ...compatibleVariations.map((v) => v.price),
        );
        setPrice(minCompatiblePrice);

        const compatiblePromo = compatibleVariations.find(
          (v) => v.promotionalPrice > 0,
        );
        if (compatiblePromo) {
          const newPromotionalPrice = calculateDiscountFromParam(
            minCompatiblePrice,
            compatiblePromo.promotionalPrice.toString(),
          );
          setPromotionalPrice(newPromotionalPrice);
        }
      } else {
        setPrice(minimunPrice || minorPrice);
        setPromotionalPrice(0);
      }

      setSelectedImg(0);
      setSku("");
    }
  }

  function changeQuantity(value: number) {
    if (config && config.content.pdv.showOutStock) {
      setQuantity(value > 0 ? value : 0);
    } else {
      const stockOk = verifyMaxStockWithCart(value);
      if (!stockOk) {
        Swal.fire({
          icon: "warning",
          title: "Estoque máximo atingido",
          text: "Não será mais possível aumentar a quantidade do produto",
        });
      } else if (value <= stock) {
        setQuantity(value > 0 ? value : 0);
      } else if (value > stock) {
        Swal.fire({
          icon: "warning",
          title: "Estoque máximo atingido",
          text: "Não será mais possível aumentar a quantidade do produto",
        });
      }
    }
  }

  function verifyMaxStockWithCart(value: number) {
    let stockOk = true;
    if (orderFinded) {
      orderFinded.products.forEach((product) => {
        if (product.quantity + value > stock && product.sku === sku) {
          stockOk = false;
        }
      });
    }
    return stockOk;
  }

  async function verifyMaxStockDatabase(value: number, locationId: number) {
    let stockOk = true;
    let quantityNow = 0;
    if (orderFinded) {
      orderFinded.products.forEach((product) => {
        if (product.sku === sku) {
          quantityNow += product.quantity;
        }
      });
    }
    return await api
      .post(
        `/api/variations/sku`,
        {
          skus: [sku],
          locationId,
          status: true,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        },
      )
      .then((response) => {
        if (
          response.data &&
          response.data.data &&
          response.data.data[0] &&
          response.data.data[0].inventory >= quantityNow + value
        ) {
          return stockOk;
        } else {
          return false;
        }
      })
      .catch((e) => {
        console.log(e);
        return false;
      });
  }

  async function addCart() {
    setLoading(true);
    const findedVariation = product?.variations.find((vari) => {
      if (vari.sku === sku) {
        const qtdSelected = Object.keys(safeJsonParse(vari.context)).length;
        let qtdFinded = 0;
        Object.entries(safeJsonParse(vari.context)).forEach((itemObject) => {
          if (selectedVariation[itemObject[0]] === itemObject[1]) {
            qtdFinded++;
          }
        });
        return qtdSelected === qtdFinded;
      }
      return false;
    });
    if (!findedVariation) {
      const referenceVariation = product?.variations[0];
      const contextKeys = referenceVariation
        ? Object.keys(safeJsonParse(referenceVariation.context))
        : [];

      const selectedKeys = Object.keys(selectedVariation);
      const missing = contextKeys.filter((key) => !selectedKeys.includes(key));

      const readable = missing
        .map((key) => {
          return key.charAt(0).toUpperCase() + key.slice(1);
        })
        .join(", ");

      Swal.fire({
        icon: "warning",
        title: "Atenção",
        text:
          missing.length > 0
            ? `Selecione: ${readable} do produto`
            : "Detalhes incompletos.",
      });

      setLoading(false);
      return;
    }

    let stockOk = false;
    if (config && config.content.pdv.showOutStock) stockOk = true;
    else
      stockOk = await verifyMaxStockDatabase(
        quantity,
        findedVariation?.locationId ? findedVariation.locationId : 0,
      );
    setLoading(false);
    if (!stockOk) {
      Swal.fire({
        icon: "warning",
        title: "Estoque máximo atingido",
        text: "Não é possível adicionar mais deste produto",
      });
    } else if (
      product !== null &&
      sku !== "" &&
      findedVariation &&
      (findedVariation.inventory > 0 ||
        (config && config.content.pdv.showOutStock)) &&
      findedVariation.status === true
    ) {
      const imageIfNotHave = variationImages[0] ? variationImages[0].image : "";
      const prod = {
        id: product_id ? parseInt(product_id) : 2,
        name: product.name,
        image: img
          ? img
          : product.img
            ? product.img
            : imageIfNotHave
              ? imageIfNotHave
              : "",
        unitPrice: price,
        promotionalPrice: parseFloat(promotionalPrice.toFixed(2)),
        quantity: quantity,
        stock: stock,
        sku: sku,
        variation: selectedVariation,
        code: product.code,
        locationId: findedVariation.locationId,
        pluginspaceHash: pluginspace_id ? pluginspace_id : "",
        outStock: false,
        measures: {
          width: findedVariation.width ? findedVariation.width : 0,
          height: findedVariation.height ? findedVariation.height : 0,
          lenght: findedVariation.depth ? findedVariation.depth : 0,
          weight: findedVariation.weight ? findedVariation.weight : 0,
        },
      };

      const prodModalCarrinho = {
        id: product_id ? parseInt(product_id) : 2,
        name: product.name,
        image: findedVariation.img
          ? findedVariation.img
          : img
            ? img
            : product.img
              ? product.img
              : imageIfNotHave
                ? imageIfNotHave
                : "",
        unitPrice: price,
        promotionalPrice: parseFloat(promotionalPrice.toFixed(2)),
        quantity: quantity,
        stock: stock,
        sku: sku,
        variation: selectedVariation,
        code: product.code,
        locationId: findedVariation.locationId,
        pluginspaceHash: pluginspace_id ? pluginspace_id : "",
        outStock: false,
        measures: {
          width: findedVariation.width ? findedVariation.width : 0,
          height: findedVariation.height ? findedVariation.height : 0,
          lenght: findedVariation.depth ? findedVariation.depth : 0,
          weight: findedVariation.weight ? findedVariation.weight : 0,
        },
      };

      pushToOrder(prod);
      addProduct(prod);
      const priceToCart = findedVariation.promotionalPrice
        ? findedVariation.promotionalPrice
        : findedVariation.price;
      trackAddToCart(priceToCart * quantity, {
        id: product_id ? parseInt(product_id) : 2,
        name: product?.name || "",
        price: priceToCart,
        quantity: quantity,
        sku: sku,
        category: subcategoryName,
      });
      setProductModal(prodModalCarrinho);
      setModalOpen(true);
      openToast("success", "Produto adicionado ao carrinho com sucesso!");
    } else {
      Swal.fire({
        icon: "warning",
        title: "Produto indisponível",
      });
    }
  }

  function contextMatchesSelected(context: any, selected: any) {
    return Object.entries(selected).every(
      ([key, value]) => context[key] === value,
    );
  }

  function selectVariationImages(contextVariation: any) {
    let findedSku = "";
    product?.variations.forEach((vt, index) => {
      const context = safeJsonParse(vt.context);
      const sizeTypes = Object.keys(context).length;
      const sizeTypesSent = Object.keys(contextVariation).length;
      let sizeComparation = 0;
      Object.keys(context).map((key) => {
        if (context[key] === contextVariation[key]) {
          sizeComparation++;
        }
      });
      if (sizeComparation === sizeTypes && sizeTypes === sizeTypesSent) {
        findedSku = vt.sku;
      }
    });

    const sortImages = variationImages
      .filter((image) => {
        if (image.sku === "") {
          return true;
        } else if (image.sku === findedSku && findedSku !== "") {
          return true;
        } else if (JSON.stringify(selectedVariation).includes("VARIATION")) {
          return true;
        } else {
          return false;
        }
      })
      .sort((a, b) => {
        if (a.sku && a.sku !== "") {
          if (b.sku && b.sku !== "") {
            return a.order - b.order;
          }
          return 1;
        }
        if (b.sku && b.sku !== "") {
          return -1;
        }
        return a.order - b.order;
      });

    setSelectedImg(0);
    setGoToLastImagem(sortImages.length - 1);
    setVariationImagesNow(sortImages);
  }

  function calculateDiscountFromParam(
    originalPrice: number,
    promotionalPrice: string,
  ) {
    try {
      const discountValueParam = query.get("discount");

      if (!discountValueParam) {
        return parseFloat(promotionalPrice);
      }

      const discountV = window.atob(discountValueParam);

      const discount = parseFloat(discountV);
      const discountValue = originalPrice * (discount / 100);
      const finalPrice = originalPrice - discountValue;
      return finalPrice;
    } catch (error) {
      return 0;
    }
  }

  const handleAnimation = (type: string) => {
    if (type === "heart") {
      setAnimateHeart(true);
      setTimeout(() => setAnimateHeart(false), 1000);
    } else if (type === "share") {
      setAnimate(true);
      setTimeout(() => setAnimate(false), 1000);
    }
  };

  // MÉTODOS DE FAVORITO ATUALIZADOS
  const saveFavorite = async () => {
    // Se o usuário não está logado, não faz nada
    if (!loginInfo?.id) return;

    if (favoriteProduct && favoriteId) {
      // Já é favorito, remover
      try {
        await api.delete(`/api/product-favorite/${favoriteId}`, {
          headers: { Authorization: `Bearer ${await getToken()}` },
        });
        setFavoriteProduct(false);
        setFavoriteId(null);
      } catch (error) {
        console.log(error);
        openToast("error", "Erro ao remover dos favoritos!");
      }
    } else {
      // Não é favorito, adicionar
      try {
        const res = await api.post(
          `/api/product-favorite`,
          {
            productId: parseInt(product_id!),
            customerId: loginInfo.id,
          },
          {
            headers: { Authorization: `Bearer ${await getToken()}` },
          },
        );

        if (res.data && res.data.success) {
          setFavoriteProduct(true);
          setFavoriteId(res.data.data.id);
          handleAnimation("heart");
        }
      } catch (error) {
        console.log(error);
        openToast("error", "Erro ao adicionar aos favoritos!");
      }
    }
  };

  return (
    <div className="product-total">
      <div className="content-product">
        {!loadingHeader && (
          <Header
            background={
              config?.webappcolor.backgroundheader
                ? config?.webappcolor.backgroundheader
                : "#F5F5F5"
            }
            colorIcon={
              config?.webappcolor.iconsheader
                ? config.webappcolor.iconsheader
                : "#636363"
            }
            logo={config?.icon ? config.icon : ""}
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
                config?.content &&
                config?.content.pdv &&
                config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
            extraSpacingLeftMenu
          />
        )}
        {loading ? (
          <div style={{ width: "100%", height: "calc(100vh)" }}>
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <>
            <HeaderCategories
              fontColor={
                config?.webappcolor.fonttitlebar
                  ? config.webappcolor.fonttitlebar
                  : "#FFFFFF"
              }
              backgroundColor={
                config?.webappcolor.backgroundtitlebar
                  ? config.webappcolor.backgroundtitlebar
                  : "#000000"
              }
              categories={[
                product?.name
                  ? product.name.length > 35
                    ? product.name.slice(0, 35).concat(`...`)
                    : product.name
                  : "",
              ]}
              blockViewMode={
                config && config.content.noUseViewMode
                  ? config.content.noUseViewMode
                  : false
              }
              shareContent
            />

            <div className="product-body">
              <ProductImage
                price={price}
                promotionalPrice={promotionalPrice}
                showFlag={showFlag}
                config={config}
                variationImagesNow={variationImagesNow}
                goToLastImagem={goToLastImagem}
                setModalImage={setModalImage}
                setUrlImageOpen={setUrlImageOpen}
                animate={animate}
                handleAnimation={handleAnimation}
                /* PASSA AS PROPS NOVAS DE FAVORITO */
                favoriteProduct={favoriteProduct}
                animateHeart={animateHeart}
                saveFavorite={saveFavorite}
                isLoggedIn={!!loginInfo?.id}
              />
              <ProductInfo
                config={config}
                product={product}
                price={price}
                promotionalPrice={promotionalPrice}
              />

              <ProductVariation
                variations={variations}
                setSelectedVariation={setSelectedVariation}
                selectedVariation={selectedVariation}
                product={product as any}
                config={config}
                selectVariation={selectVariation}
              />
              <ProductDescription
                setOpenDetails={setOpenDetails}
                openDetails={openDetails}
                description={product?.description ? product.description : ""}
                technicalDescription={
                  product?.technicalSpecification
                    ? product.technicalSpecification
                    : ""
                }
              />
              <MeasurementGuideModal
                measurementGuideProduct={measurementGuideProduct}
                imgGuide={imgGuide ?? undefined}
              />

              {(config &&
                config?.content &&
                config?.content.pdv &&
                config?.content.pdv.noSales) ||
                quantity <= 0 ? (
                <></>
              ) : (
                <div className="add-cart">
                  <ButtonProduct
                    action={async () => {
                      addCart();
                    }}
                    label={"Comprar"}
                    backgroundColor={
                      config?.webappcolor.webappbutton
                        ? config.webappcolor.webappbutton
                        : "#EAEAEA"
                    }
                    color={
                      config?.webappcolor.fontbutton
                        ? config?.webappcolor.fontbutton
                        : "#636363"
                    }
                    marginBottom
                    price={price}
                    promotionalPrice={promotionalPrice}
                    quantity={quantity}
                    onIncrease={() => changeQuantity(quantity + 1)}
                    onDecrease={() => changeQuantity(quantity - 1)}
                    inputChange={(value) => changeQuantity(value)}
                  />
                </div>
              )}
            </div>
          </>
        )}
        {!loadingHeader && (
          <Menu
            fontColor={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            activeFontColor={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#000"
            }
            backgroundMenu={
              config?.webappcolor.backgroundfooter
                ? config?.webappcolor.backgroundfooter
                : "#F5F5F5"
            }
            colorIcons={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            highlightColorIcons={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#636363"
            }
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
                config?.content &&
                config?.content.pdv &&
                config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
        {modalImage && (
          <ModalImage
            isOpen={modalImage}
            setIsOpen={setModalImage}
            urlImage={urlImageOpen}
          />
        )}
      </div>
      <ModalProdutoCarrinho
        isOpen={modalOpen}
        setIsOpen={setModalOpen}
        product={productModal}
      />
    </div>
  );
}